export class UserEntityProfileBase {
    
    id!: number
    userEntityId!: number
    type!: number
    profileId!: number

    static fromUserEntityProfile(uep: UserEntityProfile): UserEntityProfile {
        let current = new UserEntityProfileBase()
        Object.assign(current, uep)
        return current;
    }
}

export interface UserEntityProfile extends UserEntityProfileBase {

}
